<template>
  <div>
    <vue-headful title="Matches" />
    <Header page_title="Matches" />
    <div v-if="jobs && jobs.length > 0" class="">
      <div class="container-fluid app-body mt-0">
        <div class="clearfix mb-3">
          <p class="float-right mb-4">
            <strong>{{ totalMatches() }}</strong> Matches
          </p>
          <button hidden type="button" class="btn-filter position-relative p-0 m-0 float-right">
            Filter
            <div class="icon-wrapper d-inline-block">
              <i class="material-icons-round">filter_list</i>
            </div>
          </button>
        </div>
        <div v-for="job in jobs" :key="job.id" class="job-item">
          <div class="job-header">
            <div class="job-content">
              <img v-if="job.company_avatar" :src="job.company_avatar" class="company-logo"/>
              <template v-else>
                <span v-if="user.sub_branch == '1'" class="company-logo"><svg-icon icon="education" /></span>
                <span v-if="user.sub_branch == '2'" class="company-logo"><svg-icon icon="school_vo" /></span>
              </template>
              <ul class="job-specs">
                <li v-if="subtitle"><strong><svg-icon icon="calendar" />Start: {{ subtitle(job) }}</strong></li>
                <li v-if="job.sub_branch == '2'"><svg-icon icon="diploma" />{{ job.subject }} - {{ formattedGroup(job) }}</li>
                <li v-if="formattedAudience(job) && job.sub_branch == '1'"><svg-icon icon="blackboard" />groep {{ formattedAudience(job) }}</li>
                <li v-if="formattedAudience(job) && job.sub_branch == '2'"><svg-icon icon="blackboard" />{{ formattedAudience(job) }} klas</li>
                <li v-if="job.city && Object.keys(user.addresses).length > 1"><svg-icon icon="marker"></svg-icon>
                  <span v-if="job.name_location">{{ job.name_location }} ({{ job.city }})</span>
                  <span v-else>{{ job.company_name }} ({{ job.city }})</span>
                </li>
              </ul>
            </div>
            <div class="job-extra-info"><strong>Onderstaand vind je de matches op deze vacature.</strong></div>
          </div>
          <div class="applicant-overview">
            <ApplicantCard
              v-for="(match, index) in job.matches"
              :key="index"
              :applicant="addWorkingDates(match, job)"
              :view="true"
              :matchOverview="true"
              @notification="notifChanged"
              @match-id-change="matchIdChanged"
              :job-id="job.id"
              :limit-view="true"
              :limit-amount="9"
              :index="index"
            />
          </div>
        </div>
      </div>
    </div>
    <Empty v-else text="Er zijn geen matches." />
    <footer
      v-if="jobs && jobs.length > 0"
      class="bg-white fixed-btn position-fixed w-100"
      hidden
    >
      <div class="px-4 mx-2">
        <div class="container-fluid px-0">
          <a
            role="button"
            class="btn btn-warning btn-block"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
            >Filter kandidaten</a
          >
        </div>
      </div>
    </footer>
    <Footer />
  </div>
</template>

<script>
import ApplicantCard from "@/components/ApplicantCard.vue";

export default {
  data: function() {
    return {
      branch: localStorage.getItem("branch"),
      jobs: null
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData",
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.jobs = await this.getTokenAPIList("matches-per-job");
      this.user = JSON.parse(localStorage.getItem("user"));
      // if(this.jobs != null)
      // {
      //   this.jobs.forEach(function(job) {
      //     if (job.matches && job.matches.length)
      //       console.log(job.title);
      //     console.log(job.matches);
      //   });
      // }

      this.$store.state.loading = false;
    },
    async notifChanged () {
      this.fullscreen_notif = "comment"
    },
    async matchIdChanged (id, index_key) {
      this.match_id = id;
      this.match_key = index_key;
    },
    subtitle(job) {
      let working_dates = JSON.parse(JSON.parse(job.working_dates));
      let formatedFirstDate = new Date(Object.keys(working_dates)[0]).toLocaleDateString();
      let _subtitle = "";
      let locationType = "";
      if (this.branch == 2) {
        locationType = job.discipline_id == 68 ? " (BSO)" : " (dagopvang)";
      }

      if(this.user.sub_branch !== '2') {
        if(Object.keys(working_dates).length > 1)
          _subtitle = formatedFirstDate + ", " + Object.keys(working_dates).length + "\xa0dagen" + locationType;
        else
          _subtitle = formatedFirstDate + ", één dag" + locationType;
      } else {
        _subtitle = formatedFirstDate + ", " + job.periods + " lesuur (+ opslagfactor)" + locationType;
      }


      return _subtitle;
    },
    formattedAudience(job) {
      try {
        return JSON.parse(job.audience).join(', ');
      } catch (e) {
        return null;
      }
    },
    formattedGroup(job) {
      try {
        return JSON.parse(job.group).join(', ');
      } catch (e) {
        return null;
      }
    },
    totalMatches() {
      let matchesCount = 0;

      if(this.jobs != null)
      {
        this.jobs.forEach(function(job) {
          if (job.matches && job.matches.length)
            matchesCount = matchesCount + job.matches.length;
        });
      }

      return matchesCount;
    },
    addWorkingDates(match, job) {
      match.working_dates = job.working_dates;
      return match;
    }
  },
  components: {
    ApplicantCard
  }
};
</script>

<style scoped>
::v-deep .applicant-link .text.position {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 20px;
}

.job-item {
  border: 2px solid #F6F6F6;
  padding: 40px 40px 20px;
  border-radius: 10px;
  margin-bottom: 40px;
}

.job-item .job-header {
  display: block;
  margin-bottom: 40px;
}

.job-item .job-header .job-content {
  display: flex;
  align-items: center;
}

.job-item .job-header .company-logo {
  width: 80px;
  height: 80px;
  border-radius: 100%;
  border: 2px solid #F6F6F6;
}

/deep/.job-item .job-header .company-logo .svg-container {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/.job-item .job-header .company-logo .svg-container svg {
  height: 50px;
  width: 50px;
}

.job-item .job-header .job-specs {
  padding-left: 20px;
  margin-bottom: 0;
}

.job-item .job-header .job-specs li {
  display: flex;
  align-items: center;
  line-height: 1;
}

.job-item .job-header .job-specs li:not(:last-child) {
  margin-bottom: 10px;
}

/deep/ .job-item .job-header .job-specs .svg-container svg {
  height: 12px;
  width: 20px;
  color: #FFCD00;
}

.job-item .job-header .job-extra-info {
  padding-left: 105px;
  margin-top: 10px;
}

@media screen and (max-width: 500px) {
  .job-item {
    padding: 15px;
  }
}
</style>
